import { UserInfoListDto } from "../../services";
import { PermissionManager } from "./PermissionManager";

type props = {
  user: UserInfoListDto | null;
  children: JSX.Element;
};

export function RequireViewContentPermission({ user, children }: props) {
  return <>{PermissionManager.canViewContent(user) ? children : <></>}</>;
}
